<template>
  <main class="mt-3">
    <div class="container">
      <h2 class="text-center"><u>공 지 등 록</u></h2>
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label fs-5 text-center">공지제목<font class="text-danger">*</font></label>
        <div class="col-md-9">
          <input type="text" class="form-control" ref="txt_nTitle" placeholder="50자 이내" v-model="nTitle">
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label fs-5 text-center">공지내용<font class="text-danger">*</font></label>
        <div class="col-md-9">
          <!-- <input type="text" class="form-control" v-model="productInfo.pdtNameEng"> -->
          <textarea class="form-control" placeholder="1,000자 이내" ref="txt_nContent" maxlength="1000" id="floatingTextarea" style="height:500px" v-model="nContent"></textarea>
        </div>
      </div>
      <!-- <div class="mb-3 row">
        <label class="col-md-3 col-form-label">공지기간<font class="text-danger">*</font></label>
        <div class="col-md-9">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon1">개시</span>
            <date-picker class="form-control" v-model="notice.nFrom" ref="txt_fromDate" type="date" lang="en" format="YYYY-MM-DD"></date-picker>
            <span class="input-group-text" id="basic-addon1">종료</span>
            <date-picker class="form-control" v-model="notice.nTo" ref="txt_toDate" type="date" lang="en" format="YYYY-MM-DD"></date-picker>
          </div>
        </div>
      </div> -->
      <div class="mb-3 row">
        <div class="col-auto d-grid p-1">
          <button type="button" class="btn btn-lg btn-primary" @click="noticeInsert">공지등록</button>
        </div>
        <div class="col-auto d-grid p-1">
          <button type="button" class="btn btn-lg btn-success" @click="goToList">공지리스트</button>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
// import DatePicker from 'vue2-datepicker';
// import 'vue2-datepicker/index.css';
// import moment from 'moment';

export default {
  // components: {
  //   DatePicker
  // },
  data() {
    return {
      nTitle: "",
      nContent: "",
      // nFrom: "",
      // nTo: "",
      // insDate: "",
    };
  },
    // 로그인된 사용자만 접근가능페이지
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  mounted() {
    if(this.user.handlerGrade >= 5) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/b2bLogin'});
    }
    document.getElementById("user").style.display = "none";
  },
  methods: {
    goToList() {
      this.$router.push({path: '/ma_NoticeList'});
    },
    // changePdtCategory() {
    //   this.catCode = this.productInfo.catCode;
    // },
    async noticeInsert() {
      //오늘날짜추출
      // const date = new Date(+new Date() + 3240 * 10000).toISOString().split("T")[0]
      // const time = new Date().toTimeString().split(" ")[0];
      // let today = date + ' ' + time;
      // console.log("today:", date + ' ' + time);

      if(!this.nTitle) {
        this.$refs.txt_nTitle.focus();
        return this.$swal.fire("","공지제목을 입력하세요", "warning");
      }
      if(!this.nContent) {
        this.$refs.txt_nContent.focus();
        return this.$swal.fire("","공지내용을 입력하세요", "warning");
      }
      // if(!this.notice.nFrom) {
      //   this.$refs.txt_fromDate.focus();
      //   return this.$swal.fire("필수누락: 개시일");
      // }
      // if(!this.notice.nTo) {
      //   this.$refs.txt_toDate.focus();
      //   return this.$swal.fire("필수누락: 종료일");
      // }
      // if(this.notice.nStart > this.notice.nEnd) {
      //   return this.$swal.fire("입력오류: 개시일&종료일");
      // }
      // if(!this.productInfo.catCode) {
      //   this.$refs.sel_pdtCategoryt.focus();
      //   return this.$swal.fire("필수누락: 상품카테고리");
      // }
      // this.notice.nFrom = moment(this.notice.nFrom).format("YYYY-MM-DD");
      // this.notice.nTo = moment(this.notice.nTo).format("YYYY-MM-DD");
      // this.notice.insDate = today;

      let nUseFlag = "Y"; // 공지사용여부
      let userId = this.user.handlerId;
      // this.notice.nUseFlag = "Y";
      console.log("this.notice:", this.notice);

      let resIns_notice = await this.$api("/api/ins_notice_ma", {param: [
        this.nTitle, this.nContent, nUseFlag, userId
      ]});
      if(resIns_notice.affectedRows <= 0) {
        this.$swal.fire('','등록실패', 'error')
      }
      else {
        this.$swal.fire('','등록완료<br>등록과 동시에 공지가 시작됩니다.', 'success');
        this.$router.push({path: '/ma_NoticeList'});
      }
    }
  }
}
</script>